import useDrawerStore from '@/store/drawer';

export const useNavigationDrawer = () => {
  const drawerStore = useDrawerStore();
  const { visibility, component, componentProps, location, permanent, temporary } = storeToRefs(drawerStore);
  const { showDrawer, closeDrawer } = drawerStore;

  return {
    visibility,
    component,
    componentProps,
    location,
    permanent,
    temporary,
    showDrawer,
    closeDrawer,
  };
};
